export const fetchJson = async (url, options = {}) => {
  const response = await fetch(url, options);
  const clonedResponse = response.clone();
  const rawText = await clonedResponse.text();
  const contentType = (response.headers.get('content-type') || '').toLowerCase();

  if (!contentType.includes('application/json')) {
    const error = new Error(
      `Expected JSON response but received ${contentType || 'unknown content type'}`
    );
    error.status = response.status;
    error.statusText = response.statusText;
    error.bodySnippet = rawText.slice(0, 200);
    error.url = typeof url === 'string' ? url : url?.toString?.();
    throw error;
  }

  let data;
  try {
    data = rawText ? JSON.parse(rawText) : null;
  } catch (parseError) {
    const error = new Error('Failed to parse JSON response');
    error.status = response.status;
    error.statusText = response.statusText;
    error.bodySnippet = rawText.slice(0, 200);
    error.url = typeof url === 'string' ? url : url?.toString?.();
    error.parseError = parseError;
    throw error;
  }

  return { response, data };
};

export const formatFetchError = (error, fallbackMessage = 'Something went wrong. Please try again.') => {
  if (!error) {
    return fallbackMessage;
  }

  if (error.bodySnippet) {
    return `${fallbackMessage} (${error.bodySnippet.trim()})`;
  }

  if (error.message) {
    return `${fallbackMessage} (${error.message})`;
  }

  return fallbackMessage;
};
